import { render } from "./IconicTitle.vue?vue&type=template&id=66e37d8b&bindings={\"language\":\"setup\",\"lang\":\"data\",\"contentPage\":\"data\",\"env_content\":\"data\"}"
import script from "./IconicTitle.vue?vue&type=script&lang=js"
export * from "./IconicTitle.vue?vue&type=script&lang=js"

import "./IconicTitle.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script